import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  Paper,
    Collapse,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axiosInstance from "../common/axios";
import Footer from '../components/SFooter';
import Header from '../components/Header';
import orderService from '../service/orderService';
import { useAuth } from '../context/AuthContext';
import { getPaymentMethod, getMyRefunds } from '../service/refundService';
import { useLanguage } from "../context/LanguageContext";
import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';
import BackToHome from "../components/BackToHome";


const PAGE_SIZE = 10;

const RefundForm = () => {
  const [orders, setOrders] = useState([]);
  const [refunds, setRefunds] = useState([]);
  const [form, setForm] = useState({
    orderId: "",
    refundReason: "",
    refundMethodId: "",
     refundItems: []
  });
  const { user } = useAuth();
  const [showRefundSection, setShowRefundSection] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
   const [selectedItems, setSelectedItems] = useState([]);
   const [showSummary, setShowSummary] = useState(false);
   const [paymentMethods, setPaymentMethods] = useState([]);
     const { language, changeLanguage } = useLanguage();
    const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(0);
    // 3. State to track if there are more pages left
    const [hasMore, setHasMore] = useState(true);
    // 4. State for loading status (prevents rapid fetching)
    const [isLoading, setIsLoading] = useState(false);

  
  useEffect(() => {
    fetchOrders(0);
    fetchRefunds();
    fetchPaymentMethod();
  }, [user.userId]);

  const fetchPaymentMethod = async () => {
    try {
      //const res = await axiosInstance.get("/api/orders/my");
       getPaymentMethod().then(res => setPaymentMethods(res.data));
      //setOrders(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  

    const fetchOrders = useCallback(async (page) => {
        if (isLoading || !hasMore) return; // Prevent multiple requests or requests when no more data

        setIsLoading(true);
        try {
            // Service call using the updated structure (page and size)
            const response = await orderService.getUserOrder(user.userId, page,PAGE_SIZE ); 
          
            const newOrders = response.data.content;
            const totalPages = response.data.totalPages;
          
            setOrders(prevOrders => {
                // Append new orders to the existing list
                return [...prevOrders, ...newOrders];
            });
setCurrentPage(page + 1);
      //  setHasMore(false);
         
          
            // Check if we have loaded all available pages
            if (page + 1 >= totalPages) {
                setHasMore(false);
            }
          
        } catch (error) {
            console.error("Failed to fetch orders:", error);
            // Optionally handle error state
        } finally {
            setIsLoading(false);
        }
    }, [user.userId, isLoading, hasMore]); // Include dependencies
  const fetchRefunds = async () => {
    try {
      const res = await getMyRefunds(user.userId);
      setRefunds(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  
  const handleScroll = (event) => {

    const listboxNode = event.currentTarget;
    const { scrollTop, clientHeight, scrollHeight } = listboxNode;

    // Check if the user has scrolled near the bottom (within 10 pixels)
    if (scrollHeight - scrollTop <= clientHeight + 10 && hasMore && !isLoading) {
        // Load the next page
        fetchOrders(currentPage);
    }
};
  
  // helper function to calculate refund total
const calculateRefundTotal = () => {
  if (!selectedOrder || selectedItems.length === 0) return 0;

  return selectedItems.reduce((total, sel) => {
    const item = selectedOrder.items.find(
      (i) => i.orderItemId === sel.orderItemId
    );
    if (!item) return total;

    const qty = sel.quantity || 0;
    const subtotal = item.unitPrice * qty; // unitPrice * quantity
    return total + subtotal;
  }, 0);
};
  
// Toggle item selection
const handleItemToggle = (orderItemId, maxQty) => {
  setSelectedItems((prev) => {
    const exists = prev.find((sel) => sel.orderItemId === orderItemId);
    if (exists) {
      // deselect
      return prev.filter((sel) => sel.orderItemId !== orderItemId);
    } else {
      // select with default refundQty = max ordered qty
      return [...prev, { orderItemId, quantity: 1, maxQty }];
    }
  });
};


  const handleOrderChange = (event) => {
  const orderId = event.target.value;
  setForm({ ...form, orderId });

  // find the full order from the orders list
  const order = orders.find((o) => o.orderId === orderId);
  setSelectedOrder(order || null);
};
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
     if (!selectedOrder) return;
    
    const refundItems = selectedItems.map((sel) => {
  const item = selectedOrder.items.find(
    (i) => i.orderItemId === sel.orderItemId
  );
  const unitPrice = item.unitPrice || 0;
  const refundQty = sel.quantity || 1;

  return {
    orderItemId: sel.orderItemId,
    quantity: refundQty,
    itemRequestedAmount: unitPrice * refundQty, // add requested amount
  };
});
    
  const payload = {
    orderId: form.orderId,
    refundReason: form.refundReason,
    refundMethodId: form.refundMethodId,
    initiatedBy: user.userId,
    refundItems: refundItems, // now populated!
    requestedAmount: calculateRefundTotal(),
  };
    
    try {
      await axiosInstance.post("/api/refunds", payload);
      fetchRefunds();
      setForm({ orderId: "", refundReason: "", refundMethodId: "",  refundItems: [] });
     setSelectedItems([]);
      setShowSummary(false);
     setSelectedOrder(null); 
    } catch (err) {
      console.error(err);
    }
  };

  const refundColumns = [
    { field: "refundId", headerName: "ID", width: 80 },
    { field: "orderId", headerName: "Order", width: 120 },
    { field: "requestedAmount", headerName: "Amount", width: 120 },
        { field: "approvedAmount", headerName: "Approved refund Amount", width: 120 },
    { field: "refundReason", headerName: "Reason", width: 180 },
    { field: "refundStatus", headerName: "Status", width: 150 },
    { field: "createdAt", headerName: "Requested At", width: 200 },
  ];

  return (
            <>
      <Header />
      
    <Box sx={{ maxWidth: 800, mx: "auto", mt: 4 }}>
      <Paper sx={{ p: 3, mb: 4 }}>
      {!showSummary ? (
             <div style={{ marginTop: "1rem" }}>
        <Typography variant="h6" gutterBottom>
         {t('request_a_refund' , "Request a Refund")}
        </Typography>
        <Box sx={{ display: "grid", gap: 2 }}>
   
          <Select
    labelId="order-select-label"
    name="orderId"
    value={form.orderId}
    onChange={handleOrderChange}
    displayEmpty
    label="Select Order"
    
    // 👇 The Change is HERE
    MenuProps={{
        // PaperProps handles the styling and events of the scrollable container
        PaperProps: {
            // 1. Set max height to create a scrollbar
            style: {
                maxHeight: 300,
            },
            // 2. ATTACH THE SCROLL LISTENER DIRECTLY TO THE PAPER COMPONENT
            onScroll: handleScroll, 
        },
        // The onScroll property should generally be omitted here (or passed as props to the listbox if not using PaperProps)
    }}
>
    {/* ... MenuItems, Loading, and No more orders messages */}
    <MenuItem value="">
                <em>Select Order</em>
            </MenuItem>
            
            {/* Map over the cumulative list of orders */}
            {orders.map((order) => (
                <MenuItem key={order.orderId} value={order.orderId}>
                    Order #{order.orderId}
                </MenuItem>
            ))}

            {/* Display loading message at the bottom of the menu */}
            {isLoading && (
                <MenuItem disabled>
                    <em>Loading...</em>
                </MenuItem>
            )}

            {/* Display message when no more data is available */}
            {!hasMore && orders.length > PAGE_SIZE && (
                <MenuItem disabled>
                    <em>No more orders</em>
                </MenuItem>
            )}
</Select>


          <TextField
            name="refundReason"
            label="Refund Reason"
            value={form.refundReason}
            onChange={handleChange}
            fullWidth
          />
              
          <Select
        name="refundMethodId"
        value={form.refundMethodId}
        onChange={handleChange}
        displayEmpty
      >
        <MenuItem value="">
          <em>Select Refund Method</em>
        </MenuItem>
                {paymentMethods.map((s) => {
                   const translatedValue = s.translations?.find(t => t.languageCode === language);
                 return (
                   <MenuItem key={s.id} value={s.id}>
                     {translatedValue ? translatedValue.value : s.code}
                  </MenuItem>
                 );
                })}
              </Select>

    </Box>
    {/* Refund Section */}
    <Collapse in={showRefundSection}>
      <div style={{ marginTop: "1rem" }}>
        <Typography variant="h6" gutterBottom>
          Select Items to Refund
        </Typography>

  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell>Product</TableCell>
        <TableCell>Variant</TableCell>
        <TableCell align="right">Qty</TableCell>
        <TableCell align="right">Discount</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
  {selectedOrder?.items?.map((item) => {
    const selectedItem = selectedItems.find(
      (sel) => sel.orderItemId === item.orderItemId
    );
    const isSelected = !!selectedItem;

    return (
      <TableRow
        key={item.orderItemId}
        onClick={() => handleItemToggle(item.orderItemId)}
        style={{
          cursor: "pointer",
          backgroundColor: isSelected ? "#f0f8ff" : "transparent",
        }}
      >
        <TableCell>{item.productName}</TableCell>
        <TableCell>{item.productVariantName}</TableCell>
        <TableCell
          align="right"
          onClick={(e) => e.stopPropagation()} // prevents triggering row click
        >
          {isSelected ? (
            <TextField
              type="number"
              size="small"
              value={selectedItem?.quantity || 1}
              onChange={(e) => {
                const value = Math.min(
                  Number(e.target.value),
                  item.quantity
                ); // don’t exceed ordered qty
                setSelectedItems((prev) =>
                  prev.map((sel) =>
                    sel.orderItemId === item.orderItemId
                      ? { ...sel, quantity: value }
                      : sel
                  )
                );
              }}
              inputProps={{
                min: 1,
                max: item.quantity,
              }}
              style={{ width: "60px" }}
            />
          ) : (
            item.quantity
          )}
        </TableCell>
        <TableCell align="right">
          {item.discount ? `${item.discount}%` : "0%"}
        </TableCell>
      </TableRow>
    );
  })}
</TableBody>

  </Table>

        {/* Actions */}
        <div style={{ marginTop: "1rem", display: "flex", gap: "1rem" }}>
          <Button
            variant="outlined"
            onClick={() => setShowRefundSection(false)}
          >
             {t('cancel' , "Cancel")}  
          </Button>
          <Button
            variant="contained"
            onClick={() => setShowSummary(true)}
            disabled={selectedItems.length === 0}
          >
             {t('next' , "Next")}  
          </Button>
        </div>
      </div>
    </Collapse>
    </div>
     ) : (
   //Step 2: Summary 
<div style={{ marginTop: "1rem" }}>
  <Typography variant="h6" gutterBottom>
  {t('refund_summary' , "Refund Summary")}  
  </Typography>
  
   <Typography>{t('order' , "Order")} #{form.orderId}</Typography>
    <Typography>{t('refund_reason' , "Refund Reason")}: {form.refundReason}</Typography>
     <Typography> {t('refund_method' , "Refund Method")}: {form.refundMethodId}</Typography>
<Typography variant="h6" sx={{ mt: 2 }}>
   {t('refund_total' , "Refund Total")}: ₹{calculateRefundTotal().toFixed(2)}
</Typography>
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell>Product</TableCell>
        <TableCell>Variant</TableCell>
        <TableCell align="right">Refund Qty</TableCell>
        <TableCell align="right">Discount</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {selectedItems.map((sel) => {
        const item = selectedOrder.items.find(
          (i) => i.orderItemId === sel.orderItemId
        );
        return (
          <TableRow key={sel.orderItemId}>
            <TableCell>{item.productName}</TableCell>
            <TableCell>{item.productVariantName}</TableCell>
            <TableCell align="right">{sel.quantity}</TableCell>/
            <TableCell align="right">
              {item.discount ? `${item.discount}` : "0"}
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>

        {/* Summary Actions */}
        <div style={{ marginTop: "1rem", display: "flex", gap: "1rem" }}>
          <Button
            variant="outlined"
            onClick={() => setShowSummary(false)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
          >
           {t('submit_refund' , "Submit Refund")}  
          </Button>
        </div>
            </div>
    )}
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          {t('my_refund_requests' , "My Refund Requests")}
        </Typography>
        <Box sx={{ height: 400, mt: 2 }}>
          <DataGrid
            rows={refunds}
            getRowId={(row) => row.refundId}
            columns={refundColumns}
            pageSizeOptions={[5, 10]}
          />
        </Box>
      </Paper>
    </Box>
     <BackToHome />
       <Footer />
    </>
  );
};

export default RefundForm;
